export default __webpack_public_path__ + "static/media/rounded_cross.4fbe8d37.svg";